export const envConfig = {
  STUrl: process.env.REACT_APP_ST_URL,
  WZUrl: process.env.REACT_APP_WZ_URL,
  RNUrl: process.env.REACT_APP_RELEASE_NOTE_URL,
  RNMonth: process.env.REACT_APP_RELEASE_NOTE_MONTH,
  TermsUrl: process.env.REACT_APP_TERMS_DOC_URL,
  Staging: process.env.REACT_APP_ISSTAGING,
  // Defaults are the LIVE hosts, so an environment that sets neither behaves exactly as it
  // did before these were extracted. jbwui/.env.development points both at a dead
  // local path -- that override is the only thing keeping the local stack off vendor hosts,
  // so keep these two names in sync with it and with jbwui/e2e/seal.js.
  JBWLegacyUrl: process.env.REACT_APP_JBW_LEGACY_URL || "https://www.jbandassociates.biz",
  JBWAssetsUrl: process.env.REACT_APP_JBW_ASSETS_URL || "https://jbw360.jbwarranties.com",
  // Replaces https://<tblTenant.ehHost>/ in the "Open in Enterprise Hub" link (AB#420). Unset in
  // prod.env/stage.env, so deployed builds link to the tenant's own hub. .env.development points
  // it at the same dead path as the other deep links, because the host otherwise comes from the
  // database and would send a local browser to a real ServiceTitan domain.
  EHLinkBase: process.env.REACT_APP_EH_LINK_BASE,
};
